//@flow
import TrackJs from './trackjs-interface';
import GlobalData from './globalData';

const APP_ID = GlobalData.get('facebook', 'appId');
const VERSION = GlobalData.get('facebook', 'version');

function _callFBFunction(funName, ...args) {
  try {
    if (global.inServer) return;

    // Call function as part of fbAsyncInit if not ready.
    if (!GlobalData.getBool('fbSDKReady')) return _queueCall(funName, args);

    if (!Array.isArray(funName)) {
      global.FB[funName].apply(global.FB, args);
    } else {
      const obj = global.FB[funName[0]];
      obj[funName[1]].apply(obj, args);
    }
  } catch (e) {
    TrackJs.console.debug(`error: ${e}`);
    TrackJs.track("FB error");
  }
}

function _queueCall(funName, args) {
  if (!global.fbAsyncInit) return;
  const oldInit = global.fbAsyncInit.bind(global);

  global.fbAsyncInit = () => {
    oldInit();
    _callFBFunction(funName, ...args);
  };
}

export default {
  login(callback:(response:Object) => void, options:Object) {
    _callFBFunction('login', callback, options);
  },

  init() {
    if (!GlobalData.getBool('fbSDKReady') || !APP_ID || !VERSION) return;

    global.FB.init({
      appId            : APP_ID,
      autoLogAppEvents : true,
      xfbml            : true,
      version          : VERSION,
    });
  },

  AppEvents: {
    logEvent(eventName:string, valueToSum:?number, parameters:?Object) {
      _callFBFunction(['AppEvents', 'logEvent'], eventName, valueToSum, parameters);
    },

    logPageView() {
      _callFBFunction(['AppEvents', 'logPageView']);
    },
  },

  Event: {
    subscribe(eventName:string, callback:(e:Object)=>void) {
      _callFBFunction(['Event', 'subscribe'], eventName, callback);
    },

    unsubscribe(eventName:string, callback:(e:Object)=>void) {
      _callFBFunction(['Event', 'unsubscribe'], eventName, callback);
    },
  },
};
